import { t } from "i18next";
import { fileUploadAllowedExtensions, fileUploadAllowedMimeTypes, maxFileUploadSizeInByte } from "../../../constants/constants";
import DOMPurify from "dompurify";

export const removeHTMLElements = (targetText) => {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = targetText;
    var htmlRemovedText = tempElement.textContent || tempElement.innerText || '';

    return htmlRemovedText;
};

export const truncateText = (targetText, sizeLimit) => {
    var finalText = targetText;
    if (sizeLimit && targetText?.length > sizeLimit) {
        finalText = targetText.substring(0, sizeLimit) + "...";
    }

    return finalText;
};

export const removeHTMLElementsAndTruncateText = (targetText, sizeLimit) => {
    var htmlRemovedText = removeHTMLElements(targetText);

    var finalText = truncateText(htmlRemovedText, sizeLimit);
    
    return finalText;
};

export const postActionDataRefresh = (makeActiveKpiNumber, setRefreshDashboard) => {
  //Post Action Data Refresh
  var activeKPI = document.querySelectorAll(".kpi-card.active");
  if (activeKPI && activeKPI.length > 0) {
    //alert("activeKPI.length: "+activeKPI.length);
    activeKPI[0].click();
  } else {
    var deactiveKPI = document.querySelectorAll(".kpi-card");
    if (deactiveKPI && deactiveKPI.length >= makeActiveKpiNumber) {
      //alert("deactiveKPI.length: "+deactiveKPI.length);
      deactiveKPI[(makeActiveKpiNumber - 1)].click();
    } else {
      if (setRefreshDashboard) {
        setRefreshDashboard(false);
        setRefreshDashboard(true);
      } else if (deactiveKPI && deactiveKPI.length > 0) {
        //alert("deactiveKPI.length: "+deactiveKPI.length);
        deactiveKPI[0].click();
      }
    }
  }
};

export const clickFileInput = function(elem, selectorString){
    debugger;
     if (elem.target.closest('.multi-attachment-select')) {
    // Click inside filename — do NOT open file dialog
    return;
  }
     // Find the nearest wrapper that contains the input
  const wrapper = elem.target.closest(".custom-file-uploader");
  if (!wrapper) return; // safe guard

  // Find the file input inside the wrapper
  const input = wrapper.querySelector(selectorString);
  if (!input) return; // safe guard

  input.click();
  }

export const clearFileInput = function(elem, selectorString){
    //debugger;
    elem.target.parentElement.parentElement.parentElement.querySelector(selectorString).value=null;
    elem.target.parentElement.parentElement.parentElement.querySelector(selectorString).dispatchEvent(new Event('change', { bubbles: true }));
  }

export const handleFileChange = (event, labelSelector) => {
    debugger;
    const tempFile = event?.target?.files[0];
    console.log(event);
    if(event && event.target){
      if(labelSelector){
        if(tempFile?.name){
          event.target.parentElement.parentElement.querySelector(labelSelector).innerHTML=tempFile.name;
        }else{
          event.target.parentElement.parentElement.querySelector(labelSelector).innerHTML=t('general.label.no.file.chosen');
        }
      }
    }
  };

  export const selectDeptId = (state) => {
    const userCurrRole = state.role.userCurrRole;
    const departmentId = userCurrRole.department.id;
    
    // Check if the departmentId is 189
    if (departmentId === 189) {
      // Return alternate value
      return 112;
    } else {
      // Return the original departmentId
      return departmentId;
    }
  };

export const readFile = async (file) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.addEventListener("loadend", (e) => resolve(e.target.result));
        reader.addEventListener("error", reject);
        reader.readAsArrayBuffer(file);
    });
};

export const getAsByteArray = async (file) => {
    return new Uint8Array(await readFile(file));
};

export const getFileMimeType = async (file) => {
    var mimeTypeDetected = null;
    var fileByteArray = await getAsByteArray(file);
    //console.log("fileByteArray: " + fileByteArray);
    var arr = fileByteArray.subarray(0, 4);
    var fileSignature = "";
    for(var i = 0; i < arr.length; i++) {
        fileSignature += arr[i].toString(16);
    }
    console.log("File Signature: " + fileSignature);

    //Some adjustment required
    if(fileSignature.startsWith("424d")){
        fileSignature = "424d";
    }

    // Check the file signature against known types
    switch (fileSignature.toLowerCase()) {
        case "89504e47":
            mimeTypeDetected = "image/png";
            break;
        case "47494638":
            mimeTypeDetected = "image/gif";
            break;
        case "424d":
            mimeTypeDetected = "image/bmp";
            break;
        case "ffd8ffe0":
        case "ffd8ffe1":
        case "ffd8ffe2":
        case "ffd8ffe3":
        case "ffd8ffe8":
            mimeTypeDetected = "image/jpeg";
            break;
        default:
            mimeTypeDetected = "unknown"; // Or we can use the file.type as fallback
            break;
    }

    console.log("File Mime Type: " + mimeTypeDetected);

    return mimeTypeDetected;
};

export const checkImageSignatureAndSize = async (fileInput, fileErrors, setErrors, validatingError,selectedFiles) => {
    var files = fileInput.files;
    debugger;
    for (var i = 0; i < files.length; i++) {
        debugger;
        var fileNamePart = files[i].name.split(".");
        var fileExtension = fileNamePart[fileNamePart.length-1];

        console.log("# ---------------------- #");
        console.log("File Name: " + files[i].name);
        console.log("File Extension: " + fileExtension);
        console.log("File Type: " + files[i].type);
        console.log("File Size: " + files[i].size + " bytes");
        /*console.log("Parent HTML: " + $(fileInput).parent().html());
        console.log("Label HTML: " + $(fileInput).parent().find("label").html());
        console.log("Label Text: " + $(fileInput).parent().find("label").text());*/
        //debugger;
        if (selectedFiles == null || selectedFiles == undefined ) {
        if(files[i].size > maxFileUploadSizeInByte){
          debugger;
            console.log("File upload failed due to size limit exceeds " + ((maxFileUploadSizeInByte/1024)/1024) + " MB");
            fileErrors.push("File upload failed due to size limit exceeds " + ((maxFileUploadSizeInByte/1024)/1024) + " MB");
            
            return false;
        }
      }
      debugger;
      if (selectedFiles != null) {
        var totalSizeExceeded = 0;
        for (var i = 0; i < selectedFiles.length; i++) {
          debugger;
          totalSizeExceeded += selectedFiles[i].size;
        }
        if (totalSizeExceeded > maxFileUploadSizeInByte) {
          console.log("File upload failed due to size limit exceeds " + ((maxFileUploadSizeInByte/1024)/1024) + " MB");
            fileErrors.push("File upload failed due to size limit exceeds " + ((maxFileUploadSizeInByte/1024)/1024) + " MB");
            return false;
        }
      }

        if(fileExtension && fileUploadAllowedExtensions.indexOf("."+fileExtension) == -1){
            console.log(fileExtension + " doesn't contained in allowed file extension list: " + fileUploadAllowedExtensions);
            fileErrors.push("'."+fileExtension + "' is not allowed. File extension allowed are: " + fileUploadAllowedExtensions + ".");
            
            return false;
        }

        /* debugger;
        var mimeTypeDetected = await getFileMimeType(files[i], mimeTypeDetected);
        if(fileUploadAllowedMimeTypes.indexOf(mimeTypeDetected) == -1){
          debugger;
            //console.log(mimeTypeDetected + " doesn't contained in allowed mime types list: " + fileUploadAllowedMimeTypes);
            fileErrors.push("File type '"+mimeTypeDetected + "' is not allowed. File type allowed are: " + fileUploadAllowedMimeTypes + ".");
            
            if(setErrors && validatingError){
              var tempValidatingError = validatingError;
              tempValidatingError.fileUpload = "File type '"+mimeTypeDetected + "' is not allowed. File type allowed are: " + fileUploadAllowedMimeTypes + ".";
              setErrors(tempValidatingError);
            }

            return false;
        } */
        console.log("# ---------------------- #");
    }

    return true;
};

export function getYearList() {
  const currentYear = new Date().getFullYear();
  const yearList = [];

  for (let year = 2019; year <= currentYear; year++) {
    yearList.push({ id: year, value: year });
  }

  return yearList;
}

export function StringAvatar(name){
  if(!name){
  return {
      sx: {
          bgcolor: "F4F4F4",
      },
      children: "-",
  };
}
var childrenStr = name.split(' ').length > 1 ? name.split(' ')[0][0] + name.split(' ')[1][0] : name.split(' ')[0][0];
return {
  sx: {
      bgcolor: "F4F4F4",
  },
  children: childrenStr.toUpperCase(),
};
}

export function createMarkup(dirtyMarkup){
    return {__html:DOMPurify.sanitize(dirtyMarkup)}
}